document.addEventListener("DOMContentLoaded", function () {

  // Add 'active' to the first footer menu on page load
  const firstContent = document.querySelector("ul.footer-block__details-content, .ctm_docs_faq .faqs_content");
  const firstHeader = document.querySelector(".footer-block--menu h2");
  const firstIcon = firstHeader?.querySelector("span");

  if (firstContent && firstHeader && firstIcon) {
    firstContent.classList.add("active");
    firstHeader.classList.add("active");
    firstIcon.classList.remove("fa-plus");
    firstIcon.classList.add("fa-minus");
  }

  // Footer responsive accordion
  document.querySelectorAll(".footer-block--menu h2, .ctm_docs_faq h4").forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const isActive = this.classList.contains("active");
      const allLinks = document.querySelectorAll(".footer-block--menu h2, .ctm_docs_faq h4");
      const allContents = document.querySelectorAll("ul.footer-block__details-content, .ctm_docs_faq .faqs_content");
      const allIcons = document.querySelectorAll(".footer-block--menu h2 span, .ctm_docs_faq h4 span");

      allLinks.forEach(l => l.classList.remove("active"));
      allContents.forEach(c => c.classList.remove("active"));
      allIcons.forEach(i => {
        i.classList.remove("fa-minus");
        i.classList.add("fa-plus");
      });

      if (!isActive) {
        this.classList.add("active");
        const content = this.parentElement.querySelector("ul.footer-block__details-content, .ctm_docs_faq .faqs_content");
        const icon = this.querySelector("span");

        if (content) content.classList.add("active");
        if (icon) {
          icon.classList.remove("fa-plus");
          icon.classList.add("fa-minus");
        }
      }
    });
  });

// product card image change on hover and click
  document.querySelectorAll('.tg_product_card .thumbs img').forEach(function(img) {
    ['mouseenter', 'click'].forEach(function(evt) {
        img.addEventListener(evt, function() {
            let card = img.closest('.tg_product_card');
            let thumbs = card.querySelectorAll('.thumbs');

            thumbs.forEach(function(t) {
                t.classList.remove('active');
            });
            img.closest('.thumbs').classList.add('active');

            let firstThumbImg = card.querySelector('img.first_thumb');
            if (firstThumbImg) {
                firstThumbImg.src = img.src;
            }
        });
    });
}); 

  const navLinks = document.querySelectorAll(".ctm_docs_tlink a");
  const sections = [];

  // Collect only links with a valid target ID
  navLinks.forEach(link => {
    const id = link.getAttribute("href");
    if (id && id.startsWith("#") && id.length > 1) { // skip plain "#"
      const section = document.getElementById(id.slice(1));
      if (section) sections.push(section);
    }
  });

  // On click highlight
  navLinks.forEach(link => {
    link.addEventListener("click", function () {
      if (this.getAttribute("href") === "#") return; // ignore dummy link
      navLinks.forEach(l => l.classList.remove("active"));
      this.classList.add("active");
    });
  });

  // On scroll highlight
  window.addEventListener("scroll", () => {
    let current = "";
    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= 150 && rect.bottom >= 150) {
        current = section.id;
      }
    });

    if (current) {
      navLinks.forEach(link => {
        link.classList.remove("active");
        if (link.getAttribute("href") === "#" + current) {
          link.classList.add("active");
        }
      });
    }
  });
});
